import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaCasos from './TablaCasos';

const Casos: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaCasos />
  </Box>
);

export default Casos;
